export const BASE_URL = 'https://api.playdeck.io/api';
export const WS_URL = 'wss://ws.playdeck.io';
export const TEST_ENV_URL = 'mp-test.playdeck.io';
